function getFocusableElements(container) {
    return Array.from(
        container.querySelectorAll(
            "summary, a[href], button:enabled, [tabindex]:not([tabindex^='-']), [draggable], area, input:not([type=hidden]):enabled, select:enabled, textarea:enabled, object"
        )
    );
}

const trapFocusHandlers = {};
const warningTime = 3000

function trapFocus(container, elementToFocus = container) {
    var elements = getFocusableElements(container);
    var first = elements[0];
    var last = elements[elements.length - 1];

    removeTrapFocus();

    trapFocusHandlers.focusin = (event) => {
        if (
            event.target !== container &&
            event.target !== last &&
            event.target !== first
        )
        return;
        
        document.addEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.focusout = function() {
        document.removeEventListener('keydown', trapFocusHandlers.keydown);
    };

    trapFocusHandlers.keydown = function(event) {
        if (event.code.toUpperCase() !== 'TAB') return; // If not TAB key
        // On the last focusable element and tab forward, focus the first element.
        if (event.target === last && !event.shiftKey) {
        event.preventDefault();
        first.focus();
        }

        //  On the first focusable element and tab backward, focus the last element.
        if (
            (event.target === container || event.target === first) &&
            event.shiftKey
        ) {
            event.preventDefault();
            last.focus();
        }
    };

    document.addEventListener('focusout', trapFocusHandlers.focusout);
    document.addEventListener('focusin', trapFocusHandlers.focusin);

    elementToFocus.focus();
}

function pauseAllMedia() {
    document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
    });

    document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
    });

    document.querySelectorAll('video').forEach((video) => video.pause());
    document.querySelectorAll('product-model').forEach((model) => model.modelViewerUI?.pause());
}

function removeTrapFocus(elementToFocus = null) {
    document.removeEventListener('focusin', trapFocusHandlers.focusin);
    document.removeEventListener('focusout', trapFocusHandlers.focusout);
    document.removeEventListener('keydown', trapFocusHandlers.keydown);

    if (elementToFocus) elementToFocus.focus();
}

function debounce(fn, wait) {
    let t;
    return (...args) => {
        clearTimeout(t);
        t = setTimeout(() => fn.apply(this, args), wait);
    };
}

const serializeForm = form => {
    const obj = {};
    const formData = new FormData(form);
    for (const key of formData.keys()) {
        obj[key] = formData.get(key);
    }

    return JSON.stringify(obj);
};

function throttle(fn, delay) {
  let lastCall = 0;
  return function (...args) {
    const now = new Date().getTime();
    if (now - lastCall < delay) {
      return;
    }
    lastCall = now;
    return fn(...args);
  };
}

function fetchConfig(type = 'json') {
    return {
        method: 'POST',
        headers: { 'Content-Type': 'application/json', 'Accept': `application/${type}` }
    };
}

function extractContent(string) {
    var div = document.createElement('div');
    div.innerHTML = string;

    return div.textContent || div.innerText;
}

/*
 * Shopify Common JS
 *
 */
if ((typeof window.Shopify) == 'undefined') {
    window.Shopify = {};
}

Shopify.bind = function(fn, scope) {
    return function() {
        return fn.apply(scope, arguments);
    }
};

Shopify.setSelectorByValue = function(selector, value) {
    for (var i = 0, count = selector.options.length; i < count; i++) {
        var option = selector.options[i];

        if (value == option.value || value == option.innerHTML) {
            selector.selectedIndex = i;
            return i;
        }
    }
};

Shopify.addListener = function(target, eventName, callback) {
    target.addEventListener ? target.addEventListener(eventName, callback, false) : target.attachEvent('on'+eventName, callback);
};

Shopify.postLink = function(path, options) {
    options = options || {};
    var method = options['method'] || 'post';
    var params = options['parameters'] || {};

    var form = document.createElement("form");
    form.setAttribute("method", method);
    form.setAttribute("action", path);

    for(var key in params) {
        var hiddenField = document.createElement("input");

        hiddenField.setAttribute("type", "hidden");
        hiddenField.setAttribute("name", key);
        hiddenField.setAttribute("value", params[key]);
        form.appendChild(hiddenField);
    }

    document.body.appendChild(form);
    form.submit();
    document.body.removeChild(form);
};

Shopify.CountryProvinceSelector = function(country_domid, province_domid, options) {
    this.countryEl         = document.getElementById(country_domid);
    this.provinceEl        = document.getElementById(province_domid);
    this.provinceContainer = document.getElementById(options['hideElement'] || province_domid);

    Shopify.addListener(this.countryEl, 'change', Shopify.bind(this.countryHandler,this));

    this.initCountry();
    this.initProvince();
};

Shopify.CountryProvinceSelector.prototype = {
    initCountry: function() {
        var value = this.countryEl.getAttribute('data-default');
        Shopify.setSelectorByValue(this.countryEl, value);
        this.countryHandler();
    },

    initProvince: function() {
        var value = this.provinceEl.getAttribute('data-default');

        if (value && this.provinceEl.options.length > 0) {
            Shopify.setSelectorByValue(this.provinceEl, value);
        }
    },

    countryHandler: function(e) {
        var opt       = this.countryEl.options[this.countryEl.selectedIndex];
        var raw       = opt.getAttribute('data-provinces');
        var provinces = JSON.parse(raw);

        this.clearOptions(this.provinceEl);

        if (provinces && provinces.length == 0) {
            this.provinceContainer.style.display = 'none';
        } else {
            for (var i = 0; i < provinces.length; i++) {
                var opt = document.createElement('option');
                opt.value = provinces[i][0];
                opt.innerHTML = provinces[i][1];
                this.provinceEl.appendChild(opt);
            }

            this.provinceContainer.style.display = "";
        }
    },

    clearOptions: function(selector) {
        while (selector.firstChild) {
            selector.removeChild(selector.firstChild);
        }
    },

    setOptions: function(selector, values) {
        for (var i = 0, count = values.length; i < values.length; i++) {
            var opt = document.createElement('option');

            opt.value = values[i];
            opt.innerHTML = values[i];
            selector.appendChild(opt);
        }
    }
};

Shopify.formatMoney = function(cents, format) {
    if (typeof cents == 'string') { cents = cents.replace('.',''); }
    var value = '';
    var placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
    var formatString = (format || this.money_format);

    function defaultOption(opt, def) {
        return (typeof opt == 'undefined' ? def : opt);
    }

    function formatWithDelimiters(number, precision, thousands, decimal) {
        precision = defaultOption(precision, 2);
        thousands = defaultOption(thousands, ',');
        decimal   = defaultOption(decimal, '.');

        if (isNaN(number) || number == null) { return 0; }

        number = (number/100.0).toFixed(precision);

        var parts   = number.split('.'),
            dollars = parts[0].replace(/(\d)(?=(\d\d\d)+(?!\d))/g, '$1' + thousands),
            cents   = parts[1] ? (decimal + parts[1]) : '';

        return dollars + cents;
    }

    switch(formatString.match(placeholderRegex)[1]) {
        case 'amount':
            value = formatWithDelimiters(cents, 2);
            break;
        case 'amount_no_decimals':
            value = formatWithDelimiters(cents, 0);
            break;
        case 'amount_with_comma_separator':
            value = formatWithDelimiters(cents, 2, '.', ',');
            break;
        case 'amount_no_decimals_with_comma_separator':
            value = formatWithDelimiters(cents, 0, '.', ',');
            break;
    }

    return formatString.replace(placeholderRegex, value);
}
async function updateCartObj() {
    const res = await fetch('/');
    const text = await res.text();
    const parser = new DOMParser();
    const doc = parser.parseFromString(text, "text/html");

    setTimeout(function () {
        if (doc.querySelector('.cart-items')) {
            const productsArr = Array.from(doc.querySelectorAll('.gtm-cart-item')).map(el => ({
                brand: 'hyperx',
                pl: 'MS',
                cat: 'accessories',
                formFactor: el.dataset.subCat,
                subCat: el.dataset.subCat,
                list: 'cart',
                name: el.dataset.name,
                position: Number(el.dataset.position),
                price: parseFloat(el.dataset.price),
                variant: el.dataset.variant,
                id: el.dataset.id,
                quantity: Number(el.dataset.quantity)
            }));

            const cartProducts = {};

            productsArr.forEach((item, index) => {
                cartProducts[index + 1] = item;
            });

            cartData = {
                cartId: getCookieValue('cart'),
                cartValue: doc.querySelector('.cart-items').dataset.value,
                cartProducts
            }

            let index = 1
            document.querySelectorAll('.previewCartItem').forEach(item => {
                item.querySelectorAll('a').forEach(link => {
                    link.setAttribute('data-gtm-id', index)
                })
                index++
            })
        } else {
            cartData = undefined;
        }
    }, 1000)
}

Shopify.getCart = function(callback) {
    $.getJSON('/cart.js', function (cart, textStatus) {
        if ((typeof callback) === 'function') {
            callback(cart);
            setTimeout(function(){
                const products = document.querySelectorAll('.previewCartCarousel .product-item')
                if (!productMap) {
                    productMap = {}
                    products.forEach(product => {
                        productMap[Object.keys(productMap).length + 1] = {
                            brand: `hyperx`,
                            pl: 'MS',
                            cat: 'accessories',
                            subCat: product.dataset.subCat,
                            formFactor: product.dataset.subCat,
                            id: product.dataset.id,
                            list: `you-may-also-like`,
                            name: product.dataset.name,
                            position: Object.keys(productMap).length + 1,
                            price: parseFloat(product.dataset.price),
                            variant:  product.dataset.variant,
                            xsellMethod: ``,
                            xsellProdInfo: ``
                        }
                    })
                } else {
                    products.forEach(product => {
                        productMap[Object.keys(productMap).length + 1] = {
                            brand: `hyperx`,
                            pl: 'MS',
                            cat: 'accessories',
                            subCat: product.dataset.subCat,
                            formFactor: product.dataset.subCat,
                            id: product.dataset.id,
                            list: `you-may-also-like`,
                            name: product.dataset.name,
                            position: Object.keys(productMap).length + 1,
                            price: parseFloat(product.dataset.price),
                            variant:  product.dataset.variant,
                            xsellMethod: ``,
                            xsellProdInfo: ``
                        }
                    })
                }
                document.addEventListener('DOMContentLoaded', () => {
                    dataLayer.push({
                        event: 'standards.productsReady',
                    });
                });
            }, 3000)
        } else {
            Shopify.onCartUpdate(cart);
        }
    });
}

Shopify.onCartUpdate = function(cart) {
    alert('There are now ' + cart.item_count + ' items in the cart.');
}

Shopify.changeItem = function(variant_id, quantity, index, callback) {
    getCartUpdate(index, quantity, callback)
}

Shopify.removeItem = function(variant_id, index, callback) {
    getCartUpdate(index, 0, callback)
}


/* HPX- 717 Start */

function getCartUpdate(line, quantity, callback) {
    const body = JSON.stringify({
        line,
        quantity,
        sections_url: window.location.pathname,
    });
    
    const cartChangeUrl = window.routes?.cart_change_url || routes.cart_change_url || '/cart/change.js';


    const showCartUpdateLoader = () => {
        const loaderHTML = `
            <div class="loading-overlay loading-overlay--custom">
                <div class="loading-overlay__spinner">
                    <svg aria-hidden="true" focusable="false" role="presentation" class="spinner" viewBox="0 0 66 66" xmlns="http://www.w3.org/2000/svg">
                        <circle class="path" fill="none" stroke-width="6" cx="33" cy="33" r="30"></circle>
                    </svg>
                </div>
            </div>
        `;

        let cartContainer = null;

        if (document.body.classList.contains('template-cart')) {
            cartContainer = document.querySelector('[data-cart]');
        } else if (document.body.classList.contains('cart-sidebar-show')) {
            cartContainer = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');
        } else if (document.body.classList.contains('cart-modal-show')) {
            cartContainer = document.querySelector('[data-cart-modal] .previewCart-wrapper, .halo-cart-modal .previewCart-wrapper');
        }

        if (!cartContainer) return;

        cartContainer.classList.add('is-loading');

        if (!cartContainer.querySelector('.loading-overlay--custom')) {
            cartContainer.insertAdjacentHTML('afterbegin', loaderHTML);
        }
    };

    fetch(cartChangeUrl, { ...fetchConfig(), ...{ body } })
        .then((response) => {
            return response.text().then((text) => {
                return {
                    ok: response.ok,
                    status: response.status,
                    text: text
                };
            });
        })
        .then((result) => {
            let parsedState = {};

            try {
                parsedState = JSON.parse(result.text);
            } catch (e) {
                console.error(e);
            }

            const hasCartError =
                !result.ok ||
                parsedState.errors ||
                parsedState.status >= 400 ||
                parsedState.description ||
                parsedState.message;

            /* HPX-647 Start - recover cart UI when Shopify rejects quantity limit */
            if (hasCartError) {
                const rawError =
                    parsedState.errors ||
                    parsedState.description ||
                    parsedState.message ||
                    result.text ||
                    'Unable to update cart';

                showWarning(getUnifiedQtyExceededMessage(rawError), warningTime);

                /* Show existing cart loader immediately while fetching correct cart */
                showCartUpdateLoader();

                fetch('/cart.js')
                    .then((response) => response.json())
                    .then((cart) => {
                        if ((typeof callback) === 'function') {
                            callback(cart);
                        } else {
                            Shopify.onCartUpdate(cart);
                        }

                        setTimeout(updateCartObj, 1000);
                    })
                    .catch((e) => {
                        console.error(e);
                    });

                return;
            }
            /* HPX-647 End */

            if ((typeof callback) === 'function') {
                callback(parsedState);
            } else {
                Shopify.onCartUpdate(parsedState);
            }

            setTimeout(updateCartObj, 1000);
        })
        .catch((e) => {
            console.error(e);
        });
}
function hpxIsMaxQtyMessage(rawText) {
    const text = String(rawText || '').toLowerCase();

    return (
        text.includes('already in your cart') ||
        text.includes('already contains the maximum quantity') ||
        text.includes('maximum quantity') ||
        text.includes('maximum order quantity') ||
        text.includes('add-to-cart limit')
    );
}
function hpxGetAdminCartLimit($target = null, input = null) {
    const possibleValues = [
        window.cartAddLimit,
        window.cartLimit,
        window.maxCartQuantity,
        window.cartStrings?.cartAddLimit,
        input?.attr ? input.attr('max') : null,
        input?.attr ? input.attr('data-cart-limit') : null,
        input?.attr ? input.attr('data-max') : null
    ];

    if ($target && $target.length) {
        const form = $target.closest('form');

        if (form && form.length) {
            possibleValues.push(form.attr('data-cart-limit'));
            possibleValues.push(form.attr('data-max'));
            possibleValues.push(form.find('input[name="quantity"]').attr('max'));
            possibleValues.push(form.find('input[name="quantity"]').attr('data-cart-limit'));
        }
    }

    for (let i = 0; i < possibleValues.length; i++) {
        const value = parseInt(possibleValues[i], 10);

        if (!isNaN(value) && value > 0) {
            return value;
        }
    }

    return null;
}

function hpxBuildCartLimitMessage(rawText, $target = null, input = null) {
    const cartLimit = hpxGetAdminCartLimit($target, input);
    let maxQty = cartLimit || extractMaxQty(rawText);

    if (window.cartStrings?.addProductOutQuantity) {
        let message = window.cartStrings.addProductOutQuantity;

        if (message.includes('[maxQuantity]')) {
            message = message.replace('[maxQuantity]', maxQty || '');
        }

        return message;
    }

    return getUnifiedQtyExceededMessage(rawText);
}

function hpxIsAlreadyInCartLimitMessage(rawText) {
    const text = String(rawText || '').toLowerCase();

    return (
        text.includes('already in your cart') ||
        text.includes('cart already contains') ||
        text.includes('already contains the maximum quantity')
    );
}

function hpxIsPartialAddAvailabilityMessage(rawText) {
    const text = String(rawText || '').toLowerCase();

    return (
        text.includes('due to availability') ||
        (text.includes('only') && text.includes('added to your cart')) ||
        text.includes('not enough items available') ||
        text.includes('quantity of this product is insufficient')
    );
}

function hpxIsInventoryAvailabilityMessage(rawText) {
    const text = String(rawText || '').toLowerCase();

    return (
        text.includes('due to availability') ||
        text.includes('quantity of this product is insufficient') ||
        text.includes('not enough items available') ||
        (text.includes('only') && text.includes('added to your cart'))
    );
}

function hpxResetQuickShopQuantity($target) {
    const form = $target && $target.length ? $target.closest('form')[0] : null;

    if (!form) return;

    const wrapper =
        form.closest('.quickView') ||
        form.closest('.halo-quickView') ||
        form.closest('[data-quickshop]') ||
        form.closest('.variants-popup') ||
        form;

    wrapper.querySelectorAll('input[name="quantity"], input.quantity').forEach(function (input) {
        input.value = 1;
        input.setAttribute('value', '1');
    });

    wrapper.querySelectorAll('[data-gtm-quantity]').forEach(function (element) {
        element.setAttribute('data-gtm-quantity', '1');
    });
}

function hpxGetProductIdFromTarget($target) {
    const form = $target && $target.length ? $target.closest('form')[0] : null;

    if (!form) return null;

    if (form.dataset.productId) {
        return form.dataset.productId;
    }

    const dataId = form.getAttribute('data-id') || '';
    const match = dataId.match(/product-actions-(\d+)/);

    return match ? match[1] : null;
}

function hpxGetVariantInventory($target, input, variantId) {
    if (input && input.length > 0) {
        const inputInventory = parseInt(input.attr('data-inventory-quantity'), 10);

        if (!isNaN(inputInventory)) {
            return inputInventory;
        }
    }

    const form = $target && $target.length ? $target.closest('form')[0] : null;

    if (form) {
        const select = form.querySelector('select[name="id"]');

        const option = select ? Array.from(select.options).find(function (item) {
            return String(item.value) === String(variantId);
        }) : null;

        const optionInventory =
            option?.dataset?.inventoryQuantity ||
            option?.getAttribute('data-inventory-quantity');

        const parsedOptionInventory = parseInt(optionInventory, 10);

        if (!isNaN(parsedOptionInventory)) {
            return parsedOptionInventory;
        }
    }

    const productId = hpxGetProductIdFromTarget($target);
    const inventoryArray = productId ? window[`quick_view_inven_array_${productId}`] : null;

    if (inventoryArray && inventoryArray[variantId] !== undefined) {
        const inventoryFromArray = parseInt(inventoryArray[variantId], 10);

        if (!isNaN(inventoryFromArray)) {
            return inventoryFromArray;
        }
    }

    return null;
}

function hpxGetVariantPolicy($target, variantId) {
    const form = $target && $target.length ? $target.closest('form')[0] : null;

    if (form) {
        const select = form.querySelector('select[name="id"]');

        const option = select ? Array.from(select.options).find(function (item) {
            return String(item.value) === String(variantId);
        }) : null;

        const optionPolicy =
            option?.dataset?.inventoryPolicy ||
            option?.getAttribute('data-inventory-policy');

        if (optionPolicy) {
            return optionPolicy;
        }
    }

    const productId = hpxGetProductIdFromTarget($target);
    const policyArray = productId ? window[`quick_shop_policy_array_${productId}`] : null;

    if (policyArray && policyArray[variantId] !== undefined) {
        return policyArray[variantId];
    }

    return null;
}

function hpxGetCartQuantityForVariant(cart, variantId) {
    let qty = 0;

    if (cart && Array.isArray(cart.items)) {
        cart.items.forEach(function (item) {
            if (String(item.variant_id) === String(variantId)) {
                qty += Number(item.quantity || 0);
            }
        });
    }

    return qty;
}

function hpxUpdateHeaderCartCount(itemCount) {
    const count = parseInt(itemCount, 10);

    if (isNaN(count)) return;

    document.querySelectorAll('[data-cart-count]').forEach(function (element) {
        element.textContent = count >= 100
            ? (window.cartStrings?.item_99 || '99+')
            : count;
    });

    document.querySelectorAll('[data-cart-text]').forEach(function (element) {
        element.textContent = count === 1
            ? (window.cartStrings?.item || 'item')
            : (window.cartStrings?.items || 'items');
    });

    document.querySelectorAll('.cart-count-bubble').forEach(function (bubble) {
        bubble.classList.toggle('hidden', count <= 0);
    });
}

function hpxUpdateCartCount(cart) {
    if (!cart) return;

    hpxUpdateHeaderCartCount(cart.item_count);

    document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
}


function hpxRefreshHeaderCartCountFromCartJs(delay = 800) {
    setTimeout(function () {
        fetch('/cart.js', {
            method: 'GET',
            cache: 'no-store'
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Cart count refresh failed with status ' + response.status);
                }

                return response.json();
            })
            .then(function (cart) {
                hpxUpdateCartCount(cart);
            })
            .catch(function (e) {
                console.warn('HPX cart count refresh skipped:', e);
            });
    }, delay);
}

function hpxUpdateCartCount(cart) {
    if (!cart) return;

    hpxUpdateHeaderCartCount(cart.item_count);

    document.dispatchEvent(new CustomEvent('cart-update', { detail: cart }));
}
function hpxGetCartCountFromSideCartHtml(html) {
    const temp = document.createElement('div');
    temp.innerHTML = html;

    let itemCount = 0;

    temp.querySelectorAll(
        '[data-cart-quantity], input[name="updates[]"], input[name^="updates"], .quantity__input, .quantity'
    ).forEach(function (input) {
        const value = parseInt(input.value || input.getAttribute('value') || input.textContent, 10);

        if (!isNaN(value) && value > 0) {
            itemCount += value;
        }
    });

    if (itemCount <= 0) {
        const cartTextMatch = html.match(/Shopping Cart\s*(\d+)\s*items?/i);

        if (cartTextMatch && cartTextMatch[1]) {
            itemCount = parseInt(cartTextMatch[1], 10);
        }
    }

    if (itemCount <= 0) {
        const cartTextMatch = html.match(/(\d+)\s*items?/i);

        if (cartTextMatch && cartTextMatch[1]) {
            itemCount = parseInt(cartTextMatch[1], 10);
        }
    }

    return itemCount;
}

function hpxIsAlreadyInCartLimitMessage(rawText) {
    const text = String(rawText || '').toLowerCase();

    return (
        text.includes('already in your cart') ||
        text.includes('cart already contains') ||
        text.includes('already contains the maximum quantity')
    );
}

function hpxIsPartialAddAvailabilityMessage(rawText) {
    const text = String(rawText || '').toLowerCase();

    return (
        text.includes('due to availability') ||
        (text.includes('only') && text.includes('added to your cart')) ||
        text.includes('not enough items available') ||
        text.includes('quantity of this product is insufficient')
    );
}

function hpxBuildAddProductOutQuantityMessage(rawText, inventory) {
    let maxQty = null;

    if (inventory !== null && inventory !== undefined) {
        const inventoryQty = parseInt(inventory, 10);

        if (!isNaN(inventoryQty) && inventoryQty > 0) {
            maxQty = inventoryQty;
        }
    }

    if (!maxQty) {
        maxQty = extractMaxQty(rawText);
    }

    if (window.cartStrings?.addProductOutQuantity) {
        return window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', maxQty || '');
    }

    return getUnifiedQtyExceededMessage(rawText);
}

function hpxOpenCartDrawerWithLatestCart(cartData = null, options = {}) {
    const shouldOpenDrawer = options.openDrawer !== false;

    window.preventCartDrawer = false;

    const rootUrl = (window.routes?.root || window.Shopify?.routes?.root || '').replace(/\/$/, '');
    const timestamp = Date.now();

    function openDrawer() {
        if (!shouldOpenDrawer) return;

        window.preventCartDrawer = false;

        document.body.classList.remove('cart-modal-show');
        document.body.classList.remove('quickshop-popup-show');
        document.body.classList.add('cart-sidebar-show');

        setTimeout(function () {
            window.preventCartDrawer = false;
            document.body.classList.remove('cart-modal-show');
            document.body.classList.add('cart-sidebar-show');
        }, 300);
    }

    function refreshSideCartOnly() {
        const cartDropdown = document.querySelector('#halo-cart-sidebar .halo-sidebar-wrapper .previewCart-wrapper');

        if (!cartDropdown) {
            openDrawer();
            hpxRefreshHeaderCartCountFromCartJs(1000);
            return;
        }

        cartDropdown.classList.add('is-loading');

        fetch(`${rootUrl}/cart?view=ajax_side_cart&_=${timestamp}`, {
            method: 'GET',
            cache: 'no-store'
        })
            .then(function (response) {
                if (!response.ok) {
                    throw new Error('Side cart refresh failed with status ' + response.status);
                }

                return response.text();
            })
            .then(function (html) {
                cartDropdown.classList.remove('is-loading');

                const hasValidCartContent =
                    html &&
                    html.trim().length > 20 &&
                    (
                        html.includes('previewCartItem') ||
                        html.includes('cart-item') ||
                        html.includes('data-cart-quantity') ||
                        html.includes('previewCart')
                    );

                if (hasValidCartContent) {
                    cartDropdown.innerHTML = html;
                } else {
                    console.warn('HPX side cart response skipped because it looked empty.');
                }

                if (window.halo && typeof window.halo.dispatchChangeForShippingMessage === 'function') {
                    window.halo.dispatchChangeForShippingMessage();
                }

                if (window.halo && typeof window.halo.productCollectionCartSlider === 'function') {
                    window.halo.productCollectionCartSlider();
                }

                if (window.halo && typeof window.halo.updateGiftWrapper === 'function') {
                    window.halo.updateGiftWrapper();
                }

                hpxRefreshHeaderCartCountFromCartJs(600);

                openDrawer();
            })
            .catch(function (e) {
                cartDropdown.classList.remove('is-loading');
                console.warn('HPX side cart refresh failed:', e);

                hpxRefreshHeaderCartCountFromCartJs(1000);

                openDrawer();
            });
    }

    setTimeout(function () {
        refreshSideCartOnly();
    }, 1200);
}
function hpxShow429ErrorAndReload() {
    if (window.hpx429PopupActive) return;

    window.hpx429PopupActive = true;
    const message = 'Something went wrong! Please try again.';

    if (window.warningTimeout) {
        clearTimeout(window.warningTimeout);
        window.warningTimeout = null;
    }

    showWarning(message, null);

    setTimeout(function () {
        const popup = document.querySelector('[data-warning-popup]');
        if (!popup) return;

        const contentEl = popup.querySelector('[data-halo-warning-content]');


        if (contentEl) {
            contentEl.innerHTML = message;
        }

        document.body.classList.add('has-warning');

        const okButton =
            popup.querySelector('button') ||
            popup.querySelector('[data-close-warning]') ||
            popup.querySelector('[data-warning-close]') ||
            popup.querySelector('.button');

        if (!okButton) return;

        okButton.addEventListener('click', function () {
            setTimeout(function () {
                window.location.reload();
            }, 300);
        }, { once: true });
    }, 50);
}

function hpxInstallGlobal429Handler() {
    if (window.hpxGlobal429HandlerInstalled) return;

    window.hpxGlobal429HandlerInstalled = true;

    if (window.fetch) {
        const originalFetch = window.fetch;

        window.fetch = function () {
            return originalFetch.apply(this, arguments).then(function (response) {
                if (response && response.status === 429) {
                    hpxShow429ErrorAndReload();
                }

                return response;
            });
        };
    }

    if (window.jQuery) {
        jQuery(document).ajaxError(function (event, jqXHR) {
            if (jqXHR && jqXHR.status === 429) {
                hpxShow429ErrorAndReload();
            }
        });
    }
}

hpxInstallGlobal429Handler();

function hpxHandleAddItemError(XMLHttpRequest, message, variantId, $target, input) {
    let data = {};
    let rawMessage = message || '';

    try {
        data = JSON.parse(XMLHttpRequest.responseText);
        rawMessage = data.errors || data.description || data.message || rawMessage;
    } catch (e) {}

    const status = XMLHttpRequest.status;

    hpxResetQuickShopQuantity($target);

    const isTooManyRequests = status === 429;
    const isAlreadyInCartLimit = hpxIsAlreadyInCartLimitMessage(rawMessage);
    const isPartialInventoryAdd = hpxIsPartialAddAvailabilityMessage(rawMessage);

    if (isTooManyRequests) {
        hpxShow429ErrorAndReload();
        return;
    }


    if (isAlreadyInCartLimit) {
        showWarning(getUnifiedQtyExceededMessage(rawMessage), warningTime);
        return;
    }

    if (isPartialInventoryAdd) {
        showWarning(hpxBuildCartLimitMessage(rawMessage, $target, input), warningTime);
        hpxOpenCartDrawerWithLatestCart(null, { openDrawer: true });
        return;
    }

    if (hpxIsMaxQtyMessage(rawMessage)) {
        showWarning(hpxBuildCartLimitMessage(rawMessage, $target, input), warningTime);
        return;
    }

    showWarning(hpxBuildCartLimitMessage(rawMessage, $target, input), warningTime);
}

function hpxNormalizeAddQuantityBeforeSubmit(quantity, variantId, $target, input = null) {
    let requestedQty = parseInt(quantity, 10);

    const form = $target && $target.length ? $target.closest('form')[0] : null;
    const quickshop = form
        ? form.closest('[data-quickshop]') || form.closest('.variants-popup') || form
        : null;

    if (quickshop) {
        const visibleQtyInput =
            quickshop.querySelector('input[name="quantity"].quantity') ||
            quickshop.querySelector('input.quantity') ||
            quickshop.querySelector('input[name="quantity"]');

        if (visibleQtyInput) {
            const manualQty = parseInt(visibleQtyInput.value, 10);

            if (!isNaN(manualQty) && manualQty > 0) {
                requestedQty = manualQty;
            }
        }
    }

    if (isNaN(requestedQty) || requestedQty < 1) {
        requestedQty = 1;
    }

    let inventory = hpxGetVariantInventory($target, input, variantId);

    if ((inventory === null || isNaN(inventory)) && quickshop) {
        const inventoryInput =
            quickshop.querySelector('input[name="quantity"][data-inventory-quantity]') ||
            quickshop.querySelector('input.quantity[data-inventory-quantity]') ||
            quickshop.querySelector('[data-inventory-quantity]');

        if (inventoryInput) {
            const domInventory = parseInt(inventoryInput.getAttribute('data-inventory-quantity'), 10);

            if (!isNaN(domInventory) && domInventory > 0) {
                inventory = domInventory;
            }
        }
    }

    const policy = hpxGetVariantPolicy($target, variantId);

    if (
        inventory !== null &&
        !isNaN(inventory) &&
        inventory > 0 &&
        policy !== 'continue' &&
        requestedQty > inventory
    ) {
        if (quickshop) {
            quickshop.querySelectorAll('input[name="quantity"], input.quantity').forEach(function (qtyInput) {
                qtyInput.value = inventory;
                qtyInput.setAttribute('value', inventory);
            });

            quickshop.querySelectorAll('form input[type="hidden"][name="quantity"], input[type="hidden"][name="quantity"]').forEach(function (hiddenInput) {
                hiddenInput.value = inventory;
                hiddenInput.setAttribute('value', inventory);
            });

            quickshop.querySelectorAll('[data-gtm-quantity]').forEach(function (element) {
                element.setAttribute('data-gtm-quantity', inventory);
            });
        }

        window.hpxShowInventoryClampMessageAfterAdd = null;

        return inventory;
    }

    window.hpxShowInventoryClampMessageAfterAdd = null;

    return requestedQty;
}
/* HPX-717  End */

Shopify.addItem = function(variant_id, quantity, $target, callback, input = null) {
    var quantity = hpxNormalizeAddQuantityBeforeSubmit(quantity || 1, variant_id, $target, input);
    let dataForm = 'quantity=' + quantity + '&id=' + variant_id;

    if ($target.closest('form')) {
        const $thisForm = $target.closest('form');
        const $properties = $thisForm.find('[name^="properties"]');
       
        if ($properties.length) {
            $properties.each((index, element) => {
                dataForm = `${dataForm}&${$(element).attr('name')}=${$(element).val()}`;
            });
        }

    }

    var params = {
        type: 'POST',
        url: '/cart/add.js',
        data: dataForm,
        dataType: 'json',
        success: function(line_item) {
            if ((typeof callback) === 'function') {
                callback(line_item);
            } else {
                Shopify.onItemAdded(line_item);
            }
            
            hpxResetQuickShopQuantity($target);
            window.hpxShowInventoryClampMessageAfterAdd = null;

            setTimeout(updateCartObj, 1000);

        },
        error: function(XMLHttpRequest, textStatus) {
            var message = window.cartStrings.addProductOutQuantity2;
            hpxHandleAddItemError(XMLHttpRequest, message, variant_id, $target, input);
            $target.removeClass('is-loading');
        }
    };
    $.ajax(params);
};

Shopify.onItemAdded = function(line_item) {
    alert(line_item.title + ' was added to your shopping cart.');
}

/* HPX- 647 Start */
Shopify.onError = function(XMLHttpRequest, textStatus, message) {
    let data = {};

    try {
        data = JSON.parse(XMLHttpRequest.responseText);
    } catch (e) {}

    const status = XMLHttpRequest.status;
    const rawMessage = data.description || data.message || message || '';

    if (status === 429) {
        hpxShow429ErrorAndReload();
        return;
    }

    showWarning(getUnifiedQtyExceededMessage(rawMessage), warningTime);
};
/* HPX- 647 end  */

class MenuDrawer extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');
        const summaryElements = this.querySelectorAll('summary');
        this.addAccessibilityAttributes(summaryElements);

        if (navigator.platform === 'iPhone') document.documentElement.style.setProperty('--viewport-height', `${window.innerHeight}px`);

        this.addEventListener('keyup', this.onKeyUp.bind(this));
        this.addEventListener('focusout', this.onFocusOut.bind(this));
        this.bindEvents();
    }

    bindEvents() {
        this.querySelectorAll('summary').forEach(summary => summary.addEventListener('click', this.onSummaryClick.bind(this)));
        this.querySelectorAll('button').forEach(button => button.addEventListener('click', this.onCloseButtonClick.bind(this)));
    }

    addAccessibilityAttributes(summaryElements) {
        summaryElements.forEach(element => {
            element.setAttribute('role', 'button');
            element.setAttribute('aria-expanded', false);
            element.setAttribute('aria-controls', element.nextElementSibling.id);
        });
    }

    onKeyUp(event) {
        if(event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if(!openDetailsElement) return;

        openDetailsElement === this.mainDetailsToggle ? this.closeMenuDrawer(this.mainDetailsToggle.querySelector('summary')) : this.closeSubmenu(openDetailsElement);
    }

    onSummaryClick(event) {
        const summaryElement = event.currentTarget;
        const detailsElement = summaryElement.parentNode;
        const isOpen = detailsElement.hasAttribute('open');

        if (detailsElement === this.mainDetailsToggle) {
            if(isOpen) event.preventDefault();
            isOpen ? this.closeMenuDrawer(summaryElement) : this.openMenuDrawer(summaryElement);
        } else {
            trapFocus(summaryElement.nextElementSibling, detailsElement.querySelector('button'));

            setTimeout(() => {
                detailsElement.classList.add('menu-opening');
            });
        }
    }

    openMenuDrawer(summaryElement) {
        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });
        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add('overflow-hidden-mobile');
    }

    closeMenuDrawer(event, elementToFocus = false) {
        if (event !== undefined) {
            this.mainDetailsToggle.classList.remove('menu-opening');

            this.mainDetailsToggle.querySelectorAll('details').forEach(details =>  {
                details.removeAttribute('open');
                details.classList.remove('menu-opening');
            });

            this.mainDetailsToggle.querySelector('summary').setAttribute('aria-expanded', false);
            document.body.classList.remove('overflow-hidden-mobile');
            removeTrapFocus(elementToFocus);
            this.closeAnimation(this.mainDetailsToggle);
        }
    }

    onFocusOut(event) {
        setTimeout(() => {
            if (this.mainDetailsToggle.hasAttribute('open') && !this.mainDetailsToggle.contains(document.activeElement)) this.closeMenuDrawer();
        });
    }

    onCloseButtonClick(event) {
        const detailsElement = event.currentTarget.closest('details');
        this.closeSubmenu(detailsElement);
    }

    closeSubmenu(detailsElement) {
        detailsElement.classList.remove('menu-opening');
        removeTrapFocus();
        this.closeAnimation(detailsElement);
    }

    closeAnimation(detailsElement) {
        let animationStart;

        const handleAnimation = (time) => {
            if (animationStart === undefined) {
                animationStart = time;
            }

            const elapsedTime = time - animationStart;

            if (elapsedTime < 400) {
                window.requestAnimationFrame(handleAnimation);
            } else {
                detailsElement.removeAttribute('open');

                if (detailsElement.closest('details[open]')) {
                    trapFocus(detailsElement.closest('details[open]'), detailsElement.querySelector('summary'));
                }
            }
        }

        window.requestAnimationFrame(handleAnimation);
    }
}

customElements.define('menu-drawer', MenuDrawer);

class HeaderDrawer extends MenuDrawer {
    constructor() {
        super();
    }

    openMenuDrawer(summaryElement) {
        this.header = this.header || document.getElementById('shopify-section-header');
        this.borderOffset = this.borderOffset || this.closest('.header-wrapper').classList.contains('header-wrapper--border-bottom') ? 1 : 0;
        document.documentElement.style.setProperty('--header-bottom-position', `${parseInt(this.header.getBoundingClientRect().bottom - this.borderOffset)}px`);

        setTimeout(() => {
            this.mainDetailsToggle.classList.add('menu-opening');
        });

        summaryElement.setAttribute('aria-expanded', true);
        trapFocus(this.mainDetailsToggle, summaryElement);
        document.body.classList.add('overflow-hidden-mobile');
    }
}

customElements.define('header-drawer', HeaderDrawer);

class UpdateQuantity extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeCart = false;
        this.changeEvent = new Event('change', { bubbles: true })
        this.querySelectorAll('.btn-quantity').forEach(
            (button) => button.addEventListener('click', this.onButtonClick.bind(this))
        );
    }
    
     onButtonClick(event) {
        event.preventDefault();
        const $target = event.target
        let el_input = $target.parentElement.querySelector('.quantity');
        const value = Number(el_input.value);
        let inStockNumber = Number(el_input.dataset.inventoryQuantity);
        // SAFETY FIX — ensure valid number
        if (!inStockNumber || inStockNumber < 1) {
        const fallback = el_input.getAttribute('data-inventory-quantity');
        const parsed = parseInt(fallback);

        if (!isNaN(parsed) && parsed > 0) {
            inStockNumber = parsed;
        }
        }

        const buttonAdd = $target.closest('.product-form')?.querySelector('[data-btn-addtocart]');
        let newVal, checkAvailabel = false;

        const policyArray = document.body.matches('.quickshop-popup-show') ? window[`quick_shop_policy_array_${this.input.dataset.product}`] : window[`cart_selling_array_${this.dataset.product}`],
            currentId = document.body.matches('.quickshop-popup-show') ? this.closest('.productView-options').querySelector('[name="id"]').value : this.input.dataset.cartQuantityId,
            thisVariantStatus = policyArray[currentId];

        buttonAdd?.dataset.available == 'false' || buttonAdd?.dataset.available == undefined ? checkAvailabel = true : checkAvailabel = false;

        if ($target.matches('.plus')) newVal = value + 1;
        else if ($target.matches('.minus')) newVal = value - 1;
        else newVal = value;

        if (newVal < 0 ) newVal = 1;

               if (!isNaN(inStockNumber) && inStockNumber > 0 && newVal > inStockNumber && checkAvailabel && thisVariantStatus == 'deny') {
                    const message = getInputMessage(inStockNumber);
                    showWarning(message, warningTime);
                    newVal = inStockNumber;
                }

        el_input.value = newVal;

        if (typeof this.changeCart  == 'number') {clearTimeout(this.changeCart)};
        this.changeCart = setTimeout(() => {if ($target.matches('.btn-quantity')) this.input.dispatchEvent(this.changeEvent)}, 350);
    }

    quantityCheckedToBeContinue() {
        const sellingArray = window[`cart_selling_array_${this.dataset.product}`];
        return sellingArray == undefined ? false : sellingArray[this.querySelector('[name="quantity"]').dataset.cartQuantityId] === 'continue'
    }
}

class UpdateQuantityQuickShop extends HTMLElement {
    constructor() {
        super();
        this.input = this.querySelector('input');
        this.changeEvent = new Event('change', { bubbles: true })
        this.querySelectorAll('.btn-quantity').forEach(
            (button) => button.addEventListener('click', this.onChangeQuantity.bind(this))
        );
        this.input.addEventListener('change', this.onChangeQuantity.bind(this))
    }
    
    onChangeQuantity(event) {
        event.preventDefault();
        const target = event.target;
        let el_input = target.parentElement.querySelector('.quantity');
        const value = Number(el_input.value);
        const inStockNumber = Number(el_input.dataset.inventoryQuantity);
        const buttonAdd = target.closest('[data-quickshop]').querySelector('[data-btn-addtocart]');
        let newVal;

        if (target.matches('.plus')) newVal = value + 1;
        else if (target.matches('.minus')) newVal = value - 1;
        else newVal = value;

        if (newVal <= 0) newVal = 1;

       if (!isNaN(inStockNumber) && inStockNumber > 0 && newVal > inStockNumber && !buttonAdd.matches('.button--pre-untrack')) {
            newVal = inStockNumber;
        }

        
        el_input.value = newVal;
        if (target.matches('.btn-quantity')) this.input.dispatchEvent(this.changeEvent);
        const quickshop = this.closest('[data-quickshop]');
        const realQuantityInput = quickshop.querySelector('form input[type="hidden"]');
        realQuantityInput.value = newVal;
        realQuantityInput.setAttribute('value', newVal);
    }
}

class ProductScroller extends HTMLElement {
    constructor() {
        super();    
        this.container = this.querySelector('[data-drag-container]');
        this.dragParent = this.querySelector('[data-drag-parent]');

        this.initDragToScroll();
    }

    initDragToScroll() {
        const isOverflowing = (wrapper) => {
            return wrapper.clientWidth < wrapper.scrollWidth
        }
        let containerOverflowing = isOverflowing(this.container)

        if (containerOverflowing) {
            this.dragToScroll(this.container)
            return 
        }
        this.dragToScroll(this.dragParent)
    }   
    
    dragToScroll(slider) {
        let mouseDown = false;
        let start;
        let scrollLeft;
        let inactiveTimeout;

        slider.addEventListener('mousedown', (e) => {
            const target = e.target 

            mouseDown = true;
            start = e.pageX - slider.offsetLeft;
            scrollLeft = slider.scrollLeft;
        });

        slider.addEventListener('mouseup', () => {
            mouseDown = false;

            clearTimeout(inactiveTimeout)
            inactiveTimeout = setTimeout(() => {
                slider.classList.remove('active');
            }, 150)
        });

        slider.addEventListener('mousemove', (e) => {
            if(!mouseDown) return;
            e.preventDefault();

            if (!slider.classList.contains('active')) {
                slider.classList.add('active');
            }

            const x = e.pageX - slider.offsetLeft;
            const walk = (x - start) * 1; 
            slider.scrollLeft = scrollLeft - walk;
        });

        slider.addEventListener('mouseleave', () => {
            mouseDown = false;

            clearTimeout(inactiveTimeout)
            inactiveTimeout = setTimeout(() => {
                slider.classList.remove('active');
            }, 150)
        });
    }
}

class ImageToFlip extends HTMLElement {
    constructor() {
        super() 

        this.imageContainer = this; 
        this.initObserver();
    }   

    initObserver() {
        this.observer = new IntersectionObserver((entries, observer) => {
            const imageRef = entries[0]

            if (imageRef.isIntersecting) {
                imageRef.target.classList.add('show')
                observer.unobserve(imageRef.target)
            }

        }, 
        {
            threshold: 0.4 
        });
        
        this.observer.observe(this.imageContainer);
    }
}

window.addEventListener('load', () => {
    customElements.define('cart-update-quantity', UpdateQuantity);
    customElements.define('quickshop-update-quantity', UpdateQuantityQuickShop);
    customElements.define('product-scroller', ProductScroller);
    // customElements.define('image-to-flip', ImageToFlip);
})

/* HPX- 647 Modify showWarningMessage */
function showWarning(content, time = null) {
    if (window.warningTimeout) {
        clearTimeout(window.warningTimeout);
        window.warningTimeout = null;
    }
    const popup = document.querySelector('[data-warning-popup]');
    const contentEl = popup?.querySelector('[data-halo-warning-content]');
    if (!popup || !contentEl) return;
    function decodeHTML(html) {
        const txt = document.createElement('textarea');
        txt.innerHTML = html;
        let decoded = txt.value;
        txt.innerHTML = decoded;
        decoded = txt.value;
        return decoded;
    }
    let finalContent = decodeHTML(content || '');
    finalContent = finalContent.replace(/<p>\s*<\/p>/g, '');
    contentEl.innerHTML = finalContent;
    contentEl.querySelectorAll('a').forEach(link => {
        link.setAttribute('target', '_blank');
    });
    document.body.classList.add('has-warning');
    if (time) {
        window.warningTimeout = setTimeout(() => {
            document.body.classList.remove('has-warning');
        }, time);
    }
}


/* HPX- 647 start */
function getInputMessage(maxValue, inputEl = null) {
  // fallback to DOM inventory if available
  let finalMax = maxValue;
  if (inputEl && inputEl.dataset && inputEl.dataset.inventoryQuantity) {
    const domMax = parseInt(inputEl.dataset.inventoryQuantity);
    if (!isNaN(domMax) && domMax > 0) {
      finalMax = domMax;
    }
  }
  return window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', finalMax);
}

function extractMaxQty(rawText) {
  const text = String(rawText || '');
  //try to match Shopify typical wording
  let match = text.match(/only\s+(\d+)/i);
  if (match) return parseInt(match[1], 10);
  match = text.match(/maximum\s+(\d+)/i);
  if (match) return parseInt(match[1], 10);
  match = text.match(/of\s+(\d+)/i);
  if (match) return parseInt(match[1], 10);
  // fallback (last number instead of first)
  const allNumbers = text.match(/\b(\d+)\b/g);
  if (allNumbers && allNumbers.length) {
    return parseInt(allNumbers[allNumbers.length - 1], 10);
  }

  return null;
}

function isAlreadyInCartQtyMessage(rawText) {
  const text = String(rawText || '').toLowerCase();
  return text.includes('already in your cart') || text.includes('maximum quantity');
}

function isQtyExceededMessage(rawText) {
  const text = String(rawText || '').toLowerCase();
  return (
    isAlreadyInCartQtyMessage(text) ||
    (text.includes('only') && text.includes('added')) ||
    text.includes('quantity of this product is insufficient')
  );
}



function getUnifiedQtyExceededMessage(rawText) {
  const maxQty = extractMaxQty(rawText);
  // always use theme settings
  if (isAlreadyInCartQtyMessage(rawText)) {
    let msg = window.cartStrings.alreadyInCartQtyError || '';

    if (msg.includes('[maxQuantity]') && maxQty) {
      msg = msg.replace('[maxQuantity]', maxQty);
    }

    return msg;
  }
  
  if (Number.isFinite(maxQty) && window.cartStrings?.addProductOutQuantity) {
    return window.cartStrings.addProductOutQuantity.replace('[maxQuantity]', maxQty);
  }
  return window.cartStrings.addProductOutQuantity || 'Unable to update cart';
}
/*HPX-647 end */

class FadeInComponent extends HTMLElement {
    constructor() {
        super();
    }

    connectedCallback() {
        this.initObserver();
    }

    initObserver() {
        const handler = (entries, observer) => {
            if (entries[0].isIntersecting) {
                this.classList.add('fade-in');

                observer.unobserve(this);
            }
        }

        const options = {
            threshold: 0.7
        }

        this.observer = new IntersectionObserver(handler, options); 
        this.observer.observe(this);
    }
}

window.addEventListener('load', () => {
    customElements.define('fade-in-component', FadeInComponent);
    this.loadScrolling();
})

window.onscroll = () => {this.loadScrolling()};

function loadScrolling() {
    document.querySelectorAll('[data-scrolling]').forEach(element => {element.dataset.scrolling == 'vertical' ? this.scrollVertical(element) : this.scrollHorizontal(element)})
}

function scrollVertical(element) {
    const $thisItem = element.closest('.special-banner__item') || element,
        top = $thisItem.getBoundingClientRect().top,
        height = $thisItem.getBoundingClientRect().height,
        wdHeight = window.innerHeight,
        coefficient = element.scrollHeight/height,
        redundant = height >= wdHeight ? 0 : (wdHeight - height)/2;

    if (top - redundant < 0 && top > height*-1) this.scrollTop(element, (top*-1 + redundant)*coefficient)
    else if (top - redundant >= 0) this.scrollTop(element, 0)
    else this.scrollTop(element, element.scrollHeight)
}

function scrollTop(element, scope) {
    element.scrollTo({top: scope, behavior: "smooth"})
}

function scrollHorizontal(element) {
    const $thisFirst = element.querySelector('.scrolling-text__list--1'),
        $thisSecond = element.querySelector('.scrolling-text__list--2');

    if (!$thisFirst) return;
  
    const top = element.getBoundingClientRect().top,
        height = element.getBoundingClientRect().height,
        wdHeight = window.innerHeight,
        scrollWidth = $thisFirst.scrollWidth > window.innerWidth ? $thisFirst.scrollWidth - window.innerWidth : 0,
        contentHeight = $thisFirst.getBoundingClientRect().height*2,
        redundant = height >= wdHeight ? 0 : (wdHeight - height)/2,
        coefficient = scrollWidth/(height/2 + redundant - contentHeight);
    
    let scope = (top*-1 + redundant)*coefficient,
        scope2 = (height/2 - contentHeight + redundant)*coefficient - scope;
    
    if (top - redundant < 0 && top - contentHeight > height*-1/2) {scope = scope*-1; scope2 = scope2*-1}
    else if (top - redundant >= 0) {scope = 0; scope2 = scrollWidth*-1}
    else {scope = scrollWidth*-1; scope2 = 0}
    $thisFirst.scrollWidth <= window.innerWidth ? $thisSecond.style.justifyContent = 'flex-end' : this.translateX($thisFirst, $thisSecond, scope, scope2);
}

function translateX($thisFirst, $thisSecond, scope, scope2) {
    $thisFirst.style.transform = `translateX(${scope}px)`;
    $thisSecond.style.transform = `translateX(${(scope2)}px)`;
}

class SmoothScrollMenu {
    constructor(selector) {
        this.menuItems = document.querySelectorAll(selector);
        this.attachEvents();
        this.hideMenuItemsWithoutSection();
    }

    attachEvents() {
        this.menuItems.forEach(item => {
            const anchor = item.querySelector('a');
            if (anchor && anchor.getAttribute('href') && anchor.getAttribute('href') !== "#") {
                anchor.addEventListener('click', event => this.handleMenuItemClick(event, anchor));
            }
        });
    }

    handleMenuItemClick(event, anchor) {
        event.preventDefault();

        var targetHref = anchor.getAttribute('href');
        var shouldScroll = true;
        const location = window.location.pathname + window.location.hash;

        if (targetHref.includes('/') && location !== targetHref) {
            window.location.href = targetHref;
            shouldScroll = false;
        }

        if (shouldScroll) {
            var targetElement = document.getElementById(anchor.getAttribute('href').split('#')[1]);
            if (targetElement) {
                this.scrollToSection(targetElement);
            }
        }
    }

    scrollToSection(element) {
        this.smoothScrollTo(element);
    }

    smoothScrollTo(element) {
        window.scrollTo({
            behavior: 'smooth',
            top: element.offsetTop
        });
    }

    hideMenuItemsWithoutSection() {
        this.menuItems.forEach(item => {
            const anchor = item.querySelector('a');
            const hash = anchor.getAttribute('href').split('#')[1];
            if (hash !== undefined && hash !== '' && !document.getElementById(hash)) {
                item.style.display = 'none';
            }
        });
    }
}

document.addEventListener('DOMContentLoaded', function () {
    new SmoothScrollMenu('.header__inline-menu .menu-lv-1');
    customElements.define('details-disclosure', DetailsDisclosure);
});

class DetailsDisclosure extends HTMLElement {
    constructor() {
        super();
        this.mainDetailsToggle = this.querySelector('details');

        this.addEventListener('keyup', this.onKeyUp);
        this.mainDetailsToggle.addEventListener('focusout', this.onFocusOut.bind(this));
    }

    onKeyUp(event) {
        if (event.code.toUpperCase() !== 'ESCAPE') return;

        const openDetailsElement = event.target.closest('details[open]');
        if (!openDetailsElement) return;

        const summaryElement = openDetailsElement.querySelector('summary');
        openDetailsElement.removeAttribute('open');
        summaryElement.focus();
    }

    onFocusOut() {
        setTimeout(() => {
            if (!this.contains(document.activeElement)) this.close();
        })
    }

    close() {
        this.mainDetailsToggle.removeAttribute('open')
    }
}

class AccountIcon extends HTMLElement {
  constructor() {
    super();

    this.icon = this.querySelector('.icon');
  }

  connectedCallback() {
    document.addEventListener('storefront:signincompleted', this.handleStorefrontSignInCompleted.bind(this));
  }

  handleStorefrontSignInCompleted(event) {
    if (event?.detail?.avatar) {
      this.icon?.replaceWith(event.detail.avatar.cloneNode());
    }
  }
}

customElements.define('account-icon', AccountIcon);

class PositiveVibesComponent extends HTMLElement {
    constructor() {
        super();
        this.productPositiveVibes();
    }

    productPositiveVibes() {
        const parent = this.querySelector('.text-vibes');
        const children = this.querySelectorAll('.text-vibes--child');
        let currentIndex = 0;

        if (children.length > 1) {
            const newDiv = document.createElement("div");
            newDiv.classList.add("text-vibes--child");
            newDiv.innerHTML = children[0].innerHTML;
            parent.appendChild(newDiv);
            
            const childrens = parent.querySelectorAll('.text-vibes--child');
            setInterval(() => {
                const height = childrens[currentIndex].offsetHeight;
                childrens.forEach((child, index) => {
                    parent.style.cssText = `transform: translateY(${height * -currentIndex}px); transition: all .5s ease;`;
                    if (currentIndex == 0) {
                        parent.style.cssText = `transform: translateY(${height * -currentIndex}px); transition: none;`;
                    }
                });
                currentIndex = (currentIndex + 1) % childrens.length;
                this.heightPositive();
            }, 3000);
        }
    }

    heightPositive() {
        const parent = this.querySelector('.text-vibes');
        const childrens = this.querySelectorAll('.text-vibes--child');
        
        let maxHeight = 0;
        childrens.forEach(child => {
            maxHeight = Math.max(maxHeight, child.querySelector('p').offsetHeight);
        });

        this.style.minHeight = maxHeight + 'px';

        childrens.forEach(child => {
            child.style.minHeight = `${maxHeight}px`;
        });
    }
}

document.addEventListener('DOMContentLoaded', () => {
    customElements.define('positive-vibes', PositiveVibesComponent);
})

function checkTransparentHeader() {
    allowTransparent();

    if (Shopify.designMode) {
        document.addEventListener("shopify:section:load", allowTransparent);
        document.addEventListener("shopify:section:unload", allowTransparent);
        document.addEventListener("shopify:section:reorder", allowTransparent);
    }
}

function allowTransparent() {
    if (document.querySelector(".shopify-section:first-child [allow-transparent-header]")) {
        return;
    } else {
        document.querySelector("body").removeAttribute("allow-transparency");
    }
}

document.addEventListener('DOMContentLoaded', function () {
    checkTransparentHeader();
});

const PUB_SUB_EVENTS = {
    cartUpdate: 'cart-update',
    quantityUpdate: 'quantity-update',
    optionValueSelectionChange: 'option-value-selection-change',
    variantChange: 'variant-change',
    cartError: 'cart-error',
};

let subscribers = {};

function subscribe(eventName, callback) {
    if (subscribers[eventName] === undefined) {
        subscribers[eventName] = [];
    }

    subscribers[eventName] = [...subscribers[eventName], callback];

    return function unsubscribe() {
        subscribers[eventName] = subscribers[eventName].filter((cb) => {
            return cb !== callback;
        });
    };
}

function publish(eventName, data) {
    if (subscribers[eventName]) {
        subscribers[eventName].forEach((callback) => {
            callback(data);
        });
    }
}

class BulkAdd extends HTMLElement {
    constructor() {
        super();
        this.queue = [];
        this.requestStarted = false;
        this.ids = [];
    }

    startQueue(id, quantity) {
        this.queue.push({ id, quantity });
        const interval = setInterval(() => {
            if (this.queue.length > 0) {
                if (!this.requestStarted) {
                    this.sendRequest(this.queue);
                }
            } else {
                clearInterval(interval);
            }
        }, 250);
    }

    sendRequest(queue) {
        this.requestStarted = true;
        const items = {};
        queue.forEach((queueItem) => {
            items[parseInt(queueItem.id)] = queueItem.quantity;
        });
        this.queue = this.queue.filter((queueElement) => !queue.includes(queueElement));
        const quickBulkElement = this.closest('quick-order-list') || this.closest('quick-add-bulk');
        quickBulkElement.updateMultipleQty(items);
    }

    resetQuantityInput(id) {
        const input = this.querySelector(`#Quantity-${id}`);
        input.value = input.getAttribute('value');
        this.isEnterPressed = false;
    }

    setValidity(event, index, message) {
        event.target.setCustomValidity(message);
        event.target.reportValidity();
        this.resetQuantityInput(index);
        event.target.select();
    }

    validateQuantity(event) {
        const inputValue = parseInt(event.target.value);
        const index = event.target.dataset.index;

        if (inputValue < event.target.dataset.min) {
            this.setValidity(event, index, window.quickOrderListStrings.min_error.replace('[min]', event.target.dataset.min));
        } else if (inputValue > parseInt(event.target.max)) {
            this.setValidity(event, index, window.quickOrderListStrings.max_error.replace('[max]', event.target.max));
        } else if (inputValue % parseInt(event.target.step) != 0) {
            this.setValidity(event, index, window.quickOrderListStrings.step_error.replace('[step]', event.target.step));
        } else {
            event.target.setCustomValidity('');
            event.target.reportValidity();
            this.startQueue(index, inputValue);
        }
    }

    getSectionsUrl() {
        if (window.pageNumber) {
            return `${window.location.pathname}?page=${window.pageNumber}`;
        } else {
            return `${window.location.pathname}`;
        }
    }

    getSectionInnerHTML(html, selector) {
        return new DOMParser().parseFromString(html, 'text/html').querySelector(selector).innerHTML;
    }
}

if (!customElements.get('bulk-add')) {
    customElements.define('bulk-add', BulkAdd);
}

class SearchForm extends HTMLElement {
    constructor() {
      super();
      this.input = this.querySelector('input[type="search"]');
  
      if (this.input) {
        this.input.form.addEventListener('reset', this.onFormReset.bind(this));
        this.input.addEventListener('input', debounce((event) => {
          this.onChange(event);
        }, 300).bind(this))
      }
    }
  
    shouldResetForm() {
      return !document.querySelector('[aria-selected="true"] a')
    }
  
    onFormReset(event) {
      // Prevent default so the form reset doesn't set the value gotten from the url on page load
      event.preventDefault();
      // Don't reset if the user has selected an element on the predictive search dropdown
      if (this.shouldResetForm()) {
        this.input.value = '';
        this.input.focus();
      }
    }
  }
  customElements.define('search-form', SearchForm);

/* HPX-647 Start */  
  document.addEventListener('change', function (e) {
    const option = e.target.closest('select[name="id"], input[name="id"]');
    if (!option) return;

    const productCard = option.closest('.product-item');
    if (!productCard) return;

    const qtyInput = productCard.querySelector('input[name="quantity"]');
    if (!qtyInput) return;
    let selectedOption;

    if (option.tagName === 'SELECT') {
        selectedOption = option.options[option.selectedIndex];
    } else {
        selectedOption = option;
    }
    const inventoryQty =
        selectedOption?.dataset?.inventoryQuantity ||
        selectedOption?.getAttribute('data-inventory-quantity');

    if (inventoryQty) {
        qtyInput.setAttribute('data-inventory-quantity', inventoryQty);
        qtyInput.dataset.inventoryQuantity = inventoryQty;
    }
    });
/* HPX-647 End */    